import type { FC } from "react";
import { HiOutlinePhotograph } from "react-icons/hi";
import { IoIosClose } from "react-icons/io";
import { MoonLoader } from "react-spinners";
import { CampoEntrada } from "../../../pages/HomePage/Components/Modals/CrearClientesModal/CampoEntrada";
import { useEditarClienteModal } from "./editarClienteModalHooks";
import type { EditarClienteModalProps } from "./types";

export const EditarClienteModal: FC<EditarClienteModalProps> = (props) => {
  const modalState = useEditarClienteModal(props);

  if (!modalState) {
    return null;
  }

  const {
    campos,
    datosCliente,
    editarCliente,
    fechaActual,
    handleClose,
    handleCuotasPactadasChange,
    handleFormaDePagoChange,
    handleImageChange,
    handleImageTiendaChange,
    handlePorcentajeInteresChange,
    handleValorPrestamoChange,
    imagePreview,
    imageTiendaPreview,
    isSubmiting,
    opcionesFormaPago,
    selectedCliente,
  } = modalState;

  return (
    <div className="w-full min-h-screen h-screen z-30 bg-black bg-opacity-70 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] p-4 rounded-md relative max-h-[90%] overflow-y-auto">
        <div className="sticky top-2 z-10 flex justify-end h-0 pointer-events-none">
          <IoIosClose
            className="cursor-pointer bg-gray-200 rounded-full shadow-sm pointer-events-auto"
            size={40}
            onClick={handleClose}
          />
        </div>

        <h2 className="text-center text-xl font-semibold">Editar Cliente</h2>

        <form onSubmit={editarCliente} className="w-full mt-2">
          <div className="w-full flex flex-col gap-2 items-center">
            <img
              src={imagePreview ? imagePreview : String(selectedCliente.imageUrl)}
              alt="Selected"
              className="h-[200px] w-auto rounded-r-md object-cover"
            />

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md relative">
              <label
                htmlFor="imageInput"
                className="h-full w-[40px] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400 cursor-pointer"
              >
                <input
                  type="file"
                  id="imageInput"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageChange}
                />
                <HiOutlinePhotograph size={24} />
              </label>
              <input
                type="text"
                className="flex-1 rounded-r-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder={
                  imagePreview || selectedCliente?.imageUrl
                    ? "Cambiar Foto"
                    : "Agregar Foto del Cliente"
                }
                onClick={() => document.getElementById("imageInput")?.click()}
                readOnly
              />
            </div>

            <img
              src={
                imageTiendaPreview
                  ? imageTiendaPreview
                  : String(selectedCliente.imageTienda)
              }
              alt="Selected"
              className="h-[200px] w-auto rounded-r-md object-cover"
            />

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md relative">
              <label
                htmlFor="imageInputTienda"
                className="h-full w-[40px] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400 cursor-pointer"
              >
                <input
                  type="file"
                  id="imageInputTienda"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageTiendaChange}
                />
                <HiOutlinePhotograph size={24} />
              </label>
              <input
                type="text"
                className="flex-1 rounded-r-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder={
                  imageTiendaPreview || selectedCliente.imageTienda
                    ? "Cambiar Foto"
                    : "Agregar Foto de Tienda"
                }
                onClick={() =>
                  document.getElementById("imageInputTienda")?.click()
                }
                readOnly
              />
            </div>

            {campos.map(({ Icon, ...campo }) => (
              <CampoEntrada
                key={campo.placeholder}
                icono={<Icon size={24} />}
                {...campo}
              />
            ))}

            <h2 className="text-center text-xl font-semibold">
              Datos del Credito
            </h2>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Valor Prestamo
              </div>
              <input
                type="number"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                value={datosCliente.valorPrestamo}
                onChange={handleValorPrestamoChange}
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Porcentaje de interes
              </div>
              <input
                type="number"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                onChange={handlePorcentajeInteresChange}
                value={datosCliente.porcentajeInteres}
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Cuotas Pactadas
              </div>
              <input
                type="number"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                onChange={handleCuotasPactadasChange}
                value={datosCliente.cuotasPactadas}
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Pago Diario
              </div>
              <input
                type="number"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                value={datosCliente.pagoDiario}
                readOnly
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Forma de pago
              </div>
              <select
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                value={datosCliente.formaDePago}
                onChange={handleFormaDePagoChange}
              >
                {opcionesFormaPago.map((opcion) => (
                  <option key={opcion} value={opcion}>
                    {opcion.charAt(0).toUpperCase() + opcion.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Fecha Inicial
              </div>
              <input
                type="text"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                value={fechaActual}
                readOnly
              />
            </div>

            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Fecha Final
              </div>
              <input
                type="text"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                value={datosCliente.fechaFinal}
                readOnly
              />
            </div>

            <button
              type="submit"
              className="bg-[#8131bd] w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
              disabled={isSubmiting}
            >
              {isSubmiting ? (
                <MoonLoader size={20} color="#ffffff" />
              ) : (
                "Editar Cliente"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
